var getPointNum = function(num,n){  
    let str = String(num);
    let index = str.indexOf(".");
    if(index!=-1){
        var str1 = str.substring(0,index+n+1);
        str1 = Number(str1);
    }else{//没有小数点的时候也是截取2为做个判断
        str1 = num;
    }			    
    return str1;
}

export default {
    getPointNum:getPointNum,
}
